import { DatabaseFileData, DriveFiles } from 'ui-component/drive/Drive';
import { api } from './api';
export const SystemApi = api.injectEndpoints({
    endpoints: (builder) => ({
        fetchDrive: builder.query<DriveFiles, { target: string; userId: number }>({
            providesTags: ['Drive'],
            keepUnusedDataFor: 0,
            query: ({ target, userId }) => {
                return {
                    url: '/v1/drive/files',
                    method: 'POST',
                    body: { target, user_id: userId }
                };
            }
        }),
        fetchOrderDrive: builder.query<DriveFiles, { orderId: number; userId: number; target: string }>({
            providesTags: ['Drive'],
            keepUnusedDataFor: 0,
            query: ({ orderId, userId, target }) => {
                return {
                    url: '/v1/drive/order_files',
                    method: 'POST',
                    body: { order_id: orderId, user_id: userId, target }
                };
            }
        }),
        getDriveFile: builder.query<DatabaseFileData, { fileId: string; userId: number }>({
            providesTags: ['Drive'],
            keepUnusedDataFor: 0,
            query: ({ fileId, userId }) => {
                return {
                    url: '/v1/drive/file',
                    method: 'POST',
                    body: { file_id: fileId, user_id: userId }
                };
            }
        }),
        uploadDriveFile: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({ files, path, userId }: { files: File[]; path: string; userId: number }) => {
                const formData = new FormData();
                formData.append('destination', path);
                formData.append('user_id', userId.toString());
                if (files) {
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];

                        // @ts-ignore Grab full path (folder/file.ext) from webkitRelativePath if it exists, else fallback to just initial path
                        const relativePath = (file as any).webkitRelativePath || file.path;

                        // Send full relative path separately
                        formData.append(`path${i}`, relativePath);

                        // Send file itself
                        formData.append(`files${i}`, file, file.name); // keep original file name
                    }
                }

                return { url: '/v1/drive/upload', method: 'POST', body: formData };
            }
        }),
        deleteDriveItems: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({ items, userId }: { items: string[]; userId: number }) => {
                return { url: '/v1/drive/delete', method: 'POST', body: { items, user_id: userId } };
            }
        }),
        moveDriveItems: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({ items, destination, userId }: { items: string[]; destination: string; userId: number }) => {
                return { url: '/v1/drive/move', method: 'POST', body: { items, destination, user_id: userId } };
            }
        }),
        compressDriveItems: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({
                items,
                userId,
                fileName,
                destination
            }: {
                items: string[];
                userId: number;
                fileName: string;
                destination: string;
            }) => {
                return {
                    url: '/v1/drive/compress',
                    method: 'POST',
                    body: { items, user_id: userId, file_name: fileName, destination }
                };
            }
        }),
        createDriveFolder: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({ path, name, userId }: { path: string; name: string; userId: number }) => {
                return { url: '/v1/drive/create_folder', method: 'POST', body: { folder_name: name, destination: path, user_id: userId } };
            }
        }),
        renameDriveItems: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({ files, name, userId }: { files: string[]; name: string; userId: number }) => {
                return { url: '/v1/drive/rename', method: 'POST', body: { files, name, user_id: userId } };
            }
        }),
        manageDriveItems: builder.mutation({
            invalidatesTags: ['Drive'],
            query: ({
                editPermissions,
                fileId,
                isPublic,
                saveRecursively = false,
                userId,
                readPermissions
            }: {
                userId: number;
                fileId: string;
                isPublic: boolean;
                saveRecursively?: boolean;
                readPermissions: number[];
                editPermissions: number[];
            }) => {
                return {
                    url: '/v1/drive/manage',
                    method: 'POST',
                    body: {
                        user_id: userId,
                        file_id: fileId,
                        is_public: isPublic,
                        save_recursively: saveRecursively,
                        read_permissions: readPermissions,
                        edit_permissions: editPermissions
                    }
                };
            }
        })
    })
});

export const {
    useFetchDriveQuery,
    useFetchOrderDriveQuery,
    useGetDriveFileQuery,
    useUploadDriveFileMutation,
    useDeleteDriveItemsMutation,
    useMoveDriveItemsMutation,
    useCompressDriveItemsMutation,
    useCreateDriveFolderMutation,
    useRenameDriveItemsMutation,
    useManageDriveItemsMutation
} = SystemApi;
